import { ViewEmployee } from '@xeetr/types/models'
import { GripVertical, User } from 'lucide-react'

import HeaderBadges from '../common/HeaderBadges'

import { Badge } from '@/components/ui/badge'

interface Props {
  employee: ViewEmployee
  employeeIndex: number
}

const EmployeeHeader = ({ employee }: Props) => {
  return (
    <div className="flex w-full items-center justify-between gap-3">
      <div className="ml-2 flex items-center gap-4">
        <div className="flex h-16 w-16 items-center justify-center overflow-clip rounded-md bg-white">
          {employee.info.pictureUrl ? (
            <img src={employee.info.pictureUrl} alt="employee" className="object-contain" />
          ) : (
            <User className="h-12 w-12 text-gray-400" />
          )}
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <span className="text-2xl font-normal truncate">{employee.name}</span>
          <div className="flex flex-wrap gap-2">
            {(employee.services?.length ?? 0) > 0 ? (
              <HeaderBadges values={employee.services} length={5} />
            ) : (
              <Badge variant="destructive">Keine Kompetenzen</Badge>
            )}
          </div>
        </div>
      </div>
      <GripVertical className="h-5 w-5 text-slate-400" />
    </div>
  )
}
export default EmployeeHeader
